import * as relax from 'api/relaxClient';

export const checkBet = (
  bet: number = 0,
  balance: number = 0,
  isFreebets: boolean = false,
  bets: number[] = [],
) => {
  if (isFreebets || bet <= balance) {
    return false;
  }

  /*
  let newBet;
  for (let i = 0; i < bets.length; i++) {
    if (bets[i] > balance) {
      break;
    }
    newBet = bets[i];
  }
  if (newBet) {
    return newBet;
  }
  */

  relax.openQuickDeposit();
};
